import {
    aPIPaths,
    handleResponse,
    methods,
    requestJSON,
    requestBO,
    requestJSONSca
} from '../../Config'
export const FormService = {
    sendFormApplication,
    getFormApplication
}

function sendFormApplication(data) {
    return requestJSON(aPIPaths.postSaveApplicationDraft, {
        method: methods.post,
        data: data
    }).then(handleResponse)
}

function getFormApplication(data) {
    return requestJSON(aPIPaths.getApplicationDraft, {
        method: methods.get,
        data: data
    }).then(handleResponse)
}